"use client"

import { useEffect } from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faUserCircle } from "@fortawesome/free-solid-svg-icons"
import { Link } from "react-router-dom"

const Header = ({ isAuthenticated, onLogout }) => {
  useEffect(() => {
    // Inject media query into the head
    const styleSheet = document.createElement("style")
    styleSheet.type = "text/css"
    styleSheet.innerText = mediaQuery
    document.head.appendChild(styleSheet)

    // Cleanup function to remove the style tag when the component unmounts
    return () => {
      document.head.removeChild(styleSheet)
    }
  }, [])

  return (
    <nav className="navbar">
      <div className="navbar-container">
        {/* Logo that links to homepage */}
        <Link to="/" className="navbar-logo">
          <div className="navbar-logo-icon">S</div>
          <span className="navbar-logo-text">
            Shopify <span className="navbar-logo-text-bold">Scraper</span>
          </span>
        </Link>

        <div className="nav-links">
          <Link to="/home" className="nav-link try-now-link">
            TRY IT NOW <span className="new-badge">FREE</span>
          </Link>
          <Link to="/features" className="nav-link">
            FEATURES
          </Link>
          <Link to="/pricing" className="nav-link">
            PRICING
          </Link>
          <Link to="/how-it-works" className="nav-link">
            HOW IT WORKS?
          </Link>
        </div>

        <div className="nav-actions">
          {isAuthenticated ? (
            <>
              <Link to="/dashboard" className="nav-link">
                <FontAwesomeIcon icon={faUserCircle} className="user-icon" />
              </Link>
              <button onClick={onLogout} className="logout-button">
                LOGOUT
              </button>
            </>
          ) : (
            <Link to="/login" className="nav-link">
              SIGN IN
            </Link>
          )}
          <Link to="/subscription" className="upgrade-button">
            <span className="star-icon">★</span> UPGRADE NOW <span className="star-icon">★</span>
          </Link>
        </div>
      </div>

      {/* Add the CSS styles */}
      <style jsx="true">{`
        /* Navbar styles */
        .navbar {
          border-bottom: 1px solid #e5e7eb;
          background-color: #fff;
        }
        
        .navbar-container {
          max-width: 1280px;
          margin: 0 auto;
          padding: 0 1rem;
          display: flex;
          justify-content: space-between;
          height: 5rem;
          align-items: center;
        }
        
        .navbar-logo {
          display: flex;
          align-items: center;
          text-decoration: none;
          color: inherit;
        }
        
        .navbar-logo-icon {
          height: 2.8rem;
          width: 2.5rem;
          background-color: #007BFF;
          display: flex;
          align-items: center;
          justify-content: center;
          color: white;
          font-weight: bold;
          font-size: 1.25rem;
          border-radius: 0.25rem;
        }
        
        .navbar-logo-text {
          margin-left: 0.5rem;
          font-size: 1.25rem;
          font-weight: 600;
        }
        
        .navbar-logo-text-bold {
          font-weight: 700;
        }
        
        .nav-links {
          display: flex;
          align-items: center;
          gap: 1.5rem;
        }
        
        .nav-link {
          color: #374151;
          transition: color 0.2s;
          text-decoration: none;
        }
        
        .nav-link:hover {
          color: #007BFF;
        }

        .try-now-link {
          font-weight: 600;
          color: #007BFF !important;
        }

        .try-now-link:hover {
          color: #008f85 !important;
        }
        
        .nav-actions {
          display: flex;
          align-items: center;
          gap: 1rem;
        }
        
        .upgrade-button {
          background-color: white;
          border: 1px solid #f33a3a;
          color: #f33a3a;
          padding: 0.25rem 0.75rem;
          border-radius: 0.375rem;
          display: flex;
          align-items: center;
          transition: background-color 0.2s;
          text-decoration: none;
        }
        
        .upgrade-button:hover {
          background-color: #fff5f5;
        }
        
        .logout-button {
          background-color: #f33a3a;
          color: white;
          border: none;
          padding: 0.25rem 0.75rem;
          border-radius: 0.375rem;
          cursor: pointer;
          font-weight: 500;
          transition: background-color 0.2s;
        }
        
        .logout-button:hover {
          background-color: #e02e2e;
        }
        
        .user-icon {
          font-size: 1.5rem;
          color: #007BFF;
        }
        
        .new-badge {
          background-color: #ef4444;
          color: white;
          font-size: 0.75rem;
          padding: 0 0.25rem;
          border-radius: 0.25rem;
          margin-left: 0.25rem;
        }
        
        .star-icon {
          margin: 0 0.25rem;
        }
        
        /* Media queries */
        @media (max-width: 768px) {
          .navbar-container {
            flex-direction: column;
            height: auto;
            padding: 1rem;
          }
          
          .nav-links {
            display: none;
          }
          
          .nav-actions {
            margin-top: 1rem;
          }
        }
      `}</style>
    </nav>
  )
}

// Media query for small screens
const mediaQuery = `
@media (max-width: 768px) {
  .navbar-container {
    flex-direction: column;
    height: auto;
    padding: 1rem;
  }
  
  .nav-links {
    display: none;
  }
  
  .nav-actions {
    margin-top: 1rem;
  }
}`

export default Header
